export enum WorkflowStatus {
  Archived = 'archived',
  Draft = 'draft',
  Published = 'published',
}
